// @flow
import * as React from 'react';
import classNames from 'classnames';
import isEqual from 'react-fast-compare';
import styles from './NoResults.module.scss';

type Props = {
    children: React.Node,
    className?: string,
};

const NoResults = ({ className = '', children }: Props) => {
    return <div className={classNames(styles['no-results-container'], className)}>{children}</div>;
};

export default React.memo<Props>(NoResults, isEqual);
